module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reveal",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "timer"
  }, [_c('pomodoro')], 1), _vm._v(" "), _c('workout-component'), _vm._v(" "), _c('div', {
    staticClass: "slides"
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('h2', [_vm._v("How I manage time and stay fit with Vue.js")]), _vm._v(" "), _c('div', [_c('tomato')], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Hi, my name is Olga")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "logos row align-items-center"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/optiopay-logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/edera_logo.png"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("ProFitOro - part of the book")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://goo.gl/bQbwpW"
    }
  }, [_vm._v("https://goo.gl/bQbwpW")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/book_cover.png"),
      "alt": "book cover"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Not published yet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Outline")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("How I wrote my first book about Vue.js")]), _vm._v(" "), _c('li', [_vm._v("What is ProFitOro")]), _vm._v(" "), _c('li', [_vm._v("Vue, Vuex, Nuxt")]), _vm._v(" "), _c('li', [_vm._v("Firebase - auth, datastorage, database, hosting")]), _vm._v(" "), _c('li', [_vm._v("Jest - snapshot testing")]), _vm._v(" "), _c('li', [_vm._v("Trigonometry + SVG + Vue = ♥")]), _vm._v(" "), _c('li', [_vm._v("CircleCI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("How I wrote a book about Vue.js")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Learning Vue.js 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://goo.gl/1ayuof"
    }
  }, [_vm._v("https://goo.gl/1ayuof")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("I am not any Vue.js Guru")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("How it all started")]), _vm._v(" "), _c('p', [_vm._v("11/04/2016 11:30")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/email1.png"),
      "alt": "first email"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("How it all started")]), _vm._v(" "), _c('p', [_vm._v("11/04/2016 12:30")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/email2.png"),
      "alt": "lol"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("How it all started")]), _vm._v(" "), _c('p', [_vm._v("12/04/2016 09:30")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/email3.png"),
      "alt": "first email"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Family support")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/review.jpg"),
      "alt": "Reviews"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("What is the book about")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "fragment"
  }, [_vm._v("Two applications")]), _vm._v(" "), _c('li', {
    staticClass: "fragment"
  }, [_vm._v("Developed from scratch")]), _vm._v(" "), _c('li', {
    staticClass: "fragment"
  }, [_vm._v("Going through unit tests and e2e tests")]), _vm._v(" "), _c('li', {
    staticClass: "fragment"
  }, [_vm._v("Deployed + CI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Problems")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/vue2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Happiness")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/photowithbook.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Surprise")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/hackernews.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Still")]), _vm._v(" "), _c('p', [_vm._v("Writing books? Never ever again!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("All of a sudden")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/email4.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Let's do it!")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/profitoro_logo.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("What is ProFitOro?")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://profitorolife.com/"
    }
  }, [_vm._v("https://profitorolife.com/")])]), _vm._v(" "), _c('img', {
    staticClass: "not-so-big",
    attrs: {
      "src": require("./assets/images/background.png"),
      "alt": "background"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("\n          What is ProFitOro?\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Pomodoro timer")]), _vm._v(" "), _c('li', [_vm._v("Workouts")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    attrs: {
      "src": require("./assets/images/workout.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Vue, Vuex, Nuxt")]), _vm._v(" "), _c('p', [_vm._v("Nuxt is awesome")]), _vm._v(" "), _c('div', {
    staticClass: "left-column fragment"
  }, [_c('h4', [_vm._v("Vue router")]), _vm._v(" "), _c('pre', [_c('code', {
    attrs: {
      "data-trim": ""
    }
  }, [_vm._v("\n//components/Pomodoro.vue\nconst Pomodoro = {\n  template: 'Timer'\n}\n//components/About.vue\nconst About = {\n  template: 'This is ProFitOro'\n}\n//router.js\nconst router = new VueRouter({\n  routes: [\n    { path: '/pomodoro', component: Pomodoro },\n    { path: '/about', component: About }\n  ]\n})\n          ")]), _vm._v("\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "right-column fragment"
  }, [_c('h4', [_vm._v("Nuxt")]), _vm._v(" "), _c('pre', [_vm._v("            "), _c('code', [_vm._v("\n//pages/pomodoro.vue\nconst Pomodoro = {\n  template: 'Timer'\n}\n//pages/about.vue\nconst About = {\n  template: 'This is ProFitOro'\n}\n            ")]), _vm._v("\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Nuxt - middleware")]), _vm._v(" "), _c('div', {
    staticClass: "left-column fragment"
  }, [_c('pre', [_vm._v("          "), _c('code', [_vm._v("\n//middleware/authenticated.js\nexport default function ({ store, redirect }) {\n  if (!store.getters.isAuthenticated) {\n    return redirect('/')\n  }\n}\n          ")]), _vm._v("\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "right-column fragment"
  }, [_c('pre', [_vm._v("            "), _c('code', {
    staticClass: "html",
    attrs: {
      "data-trim": "",
      "data-noescape": ""
    }
  }, [_vm._v("\n//pages/workouts.vue\n<template>\n  workouts\n</template>\n<script>\n export default {\n   middleware: 'authenticated',\n }\n</script>\n<style>\n  /*...*/\n</style>\n            ")]), _vm._v("\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Firebase")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/firebase.png"),
      "alt": "Firebase"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Firebase")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "fragment"
  }, [_vm._v("Authentication")]), _vm._v(" "), _c('li', {
    staticClass: "fragment"
  }, [_vm._v("Datastorage")]), _vm._v(" "), _c('li', {
    staticClass: "fragment"
  }, [_vm._v("Real-time database")]), _vm._v(" "), _c('li', {
    staticClass: "fragment"
  }, [_vm._v("Hosting + SSL")])]), _vm._v(" "), _c('div', {
    staticClass: "fragment"
  }, [_vm._v("♥")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Firebase")]), _vm._v(" "), _c('h3', [_vm._v("Auth")]), _vm._v(" "), _c('p', [_vm._v("store/actions.js")]), _vm._v(" "), _c('pre', [_vm._v("          "), _c('code', [_vm._v("\nauthenticate ({state, dispatch}, {email, password}) {\n  firebaseApp.auth().signInWithEmailAndPassword(email, password)\n}\n          ")]), _vm._v("\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Firebase")]), _vm._v(" "), _c('h3', [_vm._v("Auth")]), _vm._v(" "), _c('p', [_vm._v("components/Login.vue")]), _vm._v(" "), _c('pre', [_vm._v("          "), _c('code', [_vm._v("\n<template>\n  <input v-model=\"email\" type=\"email\" placeholder=\"username or email address\" />\n  <input v-model=\"password\" type=\"password\" placeholder=\"password\" />\n  <button @click=\"onAuth\">Login!</button>\n</template>\n\n<script>\n  import { mapActions } from 'vuex'\n\n  export default {\n    methods: {\n      ...mapActions(['authenticate']),\n      onAuth () {\n        this.authenticate({email: this.email, password: this.password})\n      }\n    }\n  }\n</script>\n          ")]), _vm._v("\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Jest")]), _vm._v(" "), _c('h3', [_vm._v("Snapshot testing FTW")]), _vm._v(" "), _c('pre', [_vm._v("          "), _c('code', [_vm._v("\ntest('login snapshot', () => {\n  let $mounted = new Vue({\n    template: '<login-page></login-page>',\n    store: store(),\n    components: {\n      'login-page': LoginPage\n    }\n  }).$mount()\n  let $html = $mounted.$el.outerHTML\n  expect($html).toMatchSnapshot()\n})\n          ")]), _vm._v("\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("CircleCI")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./assets/images/ci.png"),
      "alt": "CI"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("CircleCI")]), _vm._v(" "), _c('h3', [_vm._v("Simple configuration")]), _vm._v(" "), _c('div', {
    staticClass: "left-column"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/workflow.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-column"
  }, [_c('pre', [_vm._v("            "), _c('code', [_vm._v("\nworkflows:\n  version: 2\n  build-and-approval-deploy:\n    jobs:\n      - build\n      - hold:\n         type: approval\n         requires:\n           - build\n      - deploy:\n          requires:\n            - hold\n            ")]), _vm._v("\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Timer")]), _vm._v(" "), _c('p', [_vm._v("Just an SVG")]), _vm._v(" "), _c('pre', [_vm._v("          "), _c('code', [_vm._v("\n"), _c('div', {
    staticClass: "center-content"
  }, [_vm._v("\n  <svg class=\"timer\" viewBox=\"0 0 200 200\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n    <circle class=\"bigCircle\" r=\"100\" cx=\"100\" cy=\"100\"></circle>\n    <circle class=\"smallCircle\" r=\"90\" cx=\"100\" cy=\"100\"></circle>\n    <path class=\"segment\" :d=\"M100,100 L100, 0 A100,100 0 0,0 X, Y z\"></path>\n  </svg>\n")]), _vm._v("\n          ")]), _vm._v("\n        ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("M - move to")]), _vm._v(" "), _c('li', [_vm._v("L - line to")]), _vm._v(" "), _c('li', [_vm._v("A - arc")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Timer")]), _vm._v(" "), _c('h3', [_vm._v("Find X and Y")]), _vm._v(" "), _c('pre', [_vm._v("          "), _c('code', [_vm._v("\n<template>\n  <svg class=\"timer\">\n    <circle class=\"bigCircle\" r=\"100\" cx=\"100\" cy=\"100\"></circle>\n    <circle class=\"smallCircle\" r=\"90\" cx=\"100\" cy=\"100\"></circle>\n    <path class=\"segment\" :d=\"path\"></path>\n  </svg>\n</template>\n<script>\n  function calcEndPoint (angle) {\n    let x, y\n\n    x = 100 - 100 * Math.sin(Math.PI * angle / 180)\n    y = 100 - 100 * Math.cos(Math.PI * angle / 180)\n\n    return {\n      x, y\n    }\n  }\n\n  function calcPath (angle) {\n    let d\n    let {x, y} = calcEndPoint(angle)\n    if (angle <= 180) {\n      d = `M100,100 L100, 0 A100,100 0 0,0 ${x}, ${y} z`\n    } else {\n      d = `M100,100  L100, 0 A100,100 0 0,0 100, 200 A100,100 0 0,0 ${x}, ${y} z`\n    }\n    return d\n  }\n  export default {\n    props: ['angle'],\n    computed: {\n      path () {\n        return calcPath(this.angle)\n      }\n    }\n  }\n</script>\n          ")]), _vm._v("\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Timer")]), _vm._v(" "), _c('h3', [_vm._v("Angle calculation")]), _vm._v(" "), _c('p', [_vm._v("Set timeout and recalculate time property")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("angle")]), _vm._v(" is a computed property")]), _vm._v(" "), _c('pre', [_vm._v("          "), _c('code', [_vm._v("\nangle () {\n  return 360 - (360 / this.time * this.timestamp)\n},\n          ")]), _vm._v("\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Was it worth it?")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("I've learned a lot")]), _vm._v(" "), _c('li', [_vm._v("I have my second book")]), _vm._v(" "), _c('li', [_vm._v("I have my ProFitOro and I use it")]), _vm._v(" "), _c('li', [_vm._v("Big win! "), _c('span', {
    staticClass: "pink"
  }, [_vm._v("♥")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "fragment"
  }, [_vm._v("Do not hesitate")]), _vm._v(" "), _c('p', {
    staticClass: "fragment"
  }, [_vm._v("Just do it "), _c('span', {
    staticClass: "big-text pink"
  }, [_vm._v("♥")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daa53c18","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 54
// module chunks = 0